<template>
  <div class="empty-state">
    <div class="empty-state__icon">
      <span class="empty-state__emoji">{{ emoji }}</span>
    </div>
    <div class="empty-state__title">{{ title }}</div>
    <div class="empty-state__description">{{ description }}</div>
    <div v-if="showButton" class="empty-state__button">
      <button class="empty-state__btn" @click="handleClick">{{ buttonText }}</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EmptyState',
  props: {
    title: {
      type: String,
      default: '暂无数据'
    },
    description: {
      type: String,
      default: '没有找到相关内容'
    },
    emoji: {
      type: String,
      default: '📭'
    },
    showButton: {
      type: Boolean,
      default: false
    },
    buttonText: {
      type: String,
      default: '返回首页'
    }
  },
  methods: {
    handleClick() {
      this.$emit('click')
    }
  }
}
</script>

<style lang="scss" scoped>
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  text-align: center;

  &__icon {
    margin-bottom: 16px;
  }

  &__emoji {
    font-size: 48px;
  }

  &__title {
    font-size: 16px;
    font-weight: 600;
    color: #111827;
    margin-bottom: 8px;
  }

  &__description {
    font-size: 14px;
    color: #6b7280;
    margin-bottom: 24px;
  }

  &__button {
    width: 100%;
  }

  &__btn {
    width: 100%;
    max-width: 200px;
    padding: 10px 20px;
    background: linear-gradient(90deg, #ffa43a 0%, #ff720d 100%);
    color: #fff;
    border: none;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;

    &:active {
      opacity: 0.8;
    }
  }
}
</style>
